import { NoUnusedPermit2NonceError } from '@morpho-org/morpho-sdk'

import { logger } from '@/lib/observability/logger'

export class UnsupportedRequirementError extends Error {
  constructor(readonly type: string) {
    super(`Unsupported transaction requirement: ${type}`)
    this.name = 'UnsupportedRequirementError'
  }
}

const UNSUPPORTED_REQUIREMENT_MESSAGE =
  "This transaction requires a step this app can't process yet."
const GENERIC_REQUIREMENT_MESSAGE =
  "This transaction can't be prepared right now. Please try again."
const NO_UNUSED_PERMIT2_NONCE_MESSAGE =
  'This wallet can\'t authorize with a Permit2 signature right now. Turn off "Allow offchain signature flows" in the wallet menu and try again.'
const loggedErrors = new WeakSet<object>()

export const getRequirementsErrorMessage = (error: unknown): string => {
  const isObjectError = typeof error === 'object' && error !== null

  if (!isObjectError || !loggedErrors.has(error)) {
    if (isObjectError) loggedErrors.add(error)

    logger.error(error instanceof Error ? error : new Error(String(error)), {
      tags: { component: 'requirements' }
    })
  }

  if (error instanceof UnsupportedRequirementError) return UNSUPPORTED_REQUIREMENT_MESSAGE
  if (error instanceof NoUnusedPermit2NonceError) return NO_UNUSED_PERMIT2_NONCE_MESSAGE
  return GENERIC_REQUIREMENT_MESSAGE
}
